import React from 'react';
import { Box, Typography } from '@mui/joy';
import LocusLogo from './LocusLogo';

const BrandMark = ({ subtitle = 'Stock Management', compact = false }) => (
  <Box sx={{ textAlign: 'center', mb: compact ? 1 : 2 }}>
    <LocusLogo
      width={compact ? 220 : 300}
      height={compact ? 72 : 100}
      sx={{
        width: '100%',
        maxWidth: compact ? 220 : 300,
        mx: 'auto',
        mb: subtitle ? 1 : 0
      }}
    />
    {subtitle && (
      <Typography level="body-sm" fontWeight="lg" sx={{ color: 'primary.500', mt: 0.5 }}>
        {subtitle}
      </Typography>
    )}
  </Box>
);

export default BrandMark;
